export default {
  firstName: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-1000',
          domain: 'DDEM'
        }
      ]
    }
  },
  lastName: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-1100',
          domain: 'DDEM'
        }
      ]
    }
  },
  dob: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-1200',
          domain: 'DDEM'
        }
      ]
    }
  },
  gender: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-1300',
          domain: 'DDEM'
        }
      ]
    }
  },
  SSN: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-1400',
          domain: 'DDEM'
        }
      ]
    }
  },
  maritalStatus: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-1500',
          domain: 'DDEM'
        }
      ]
    }
  },
  // race: {
  //   unDocumented: {
  //     issues: [
  //       { id: 'I-DEM-PAT-1600',
  //        domain: 'DDEM'
  //       }
  //     ]
  //   }
  // },
  // preferredLanguage: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PAT-1700",
  //         domain: "DDEM"
  //       }
  //     ]
  //   }
  // },
  // educationLevel: {
  //   unDocumented: {
  //     issues: [
  //       { id: 'I-DEM-PAT-1800',
  //        domain: 'DDEM'
  //       }
  //     ]
  //   }
  // },
  address1: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-1900',
          domain: 'DDEM'
        }
      ]
    }
  },
  city: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-2000',
          domain: 'DDEM'
        }
      ]
    }
  },
  // county: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PAT-2100",
  //         domain: "DDEM"
  //       }
  //     ]
  //   }
  // },
  usState: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-2200',
          domain: 'DDEM'
        }
      ]
    }
  },
  zip: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-2300',
          domain: 'DDEM'
        }
      ]
    }
  },
  phones: {
    phoneType: {
      unDocumented: {
        issues: [
          {
            id: 'I-DEM-PAT-2400',
            domain: 'DDEM'
          }
        ]
      }
    },
    number: {
      unDocumented: {
        issues: [
          {
            id: 'I-DEM-PAT-2500',
            domain: 'DDEM'
          }
        ]
      }
    }
  },
  supportiveEmployer: {
    issues: [
      {
        id: 'I-DEM-PAT-2600',
        domain: 'DPFC'
      }
    ],
    triggerValue: 'no'
  },
  writtenConsent: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PAT-2700',
          domain: 'DDEM'
        }
      ]
    }
  }
}
